
<template>
  <div class="downTip" v-if="popShow">
      <img src="../images/downTip.png" alt="">
  </div>
</template>

<script>
import global from "../js/global.js"
export default {
  data () {
    return {
    }
  },
  props:["popShow"],
  created(){
  },
  mounted(){
  },
  methods:{
    closeFun(){
      this.$parent.closeTip();
    }
  }
}
</script>
<style lang="less" scoped>
.downTip{
    position: fixed;
    z-index: 999;
    width: 100%;
    height: 100%;
    top:0;
    left: 0;
    background: rgba(4,4,15,0.8);
    img{
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/downTip.vue